import { useToastStore } from './toastStore';
import { bt } from '../i18n';

/**
 * In-app toast host (build-plan §7.3 / §7.9). Mounted once at the shell root; renders the toast store's
 * queue inside a polite-by-default live region (errors are assertive). Replaces every native
 * alert/confirm path for transient feedback (e.g. an `addBlock` rejected at the block cap).
 */
export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="bld-toasts" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`bld-toast bld-toast--${t.tone}`}
          role={t.tone === 'error' ? 'alert' : 'status'}
        >
          <span className="bld-toast__msg">{t.message}</span>
          <button
            type="button"
            className="bld-toast__close"
            aria-label={bt('chrome.common.dismiss', 'Dismiss')}
            onClick={() => dismiss(t.id)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
